var _path, _path2, _path3, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCro(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 0L11.48 1.97246L14.9282 4L14.96 8L14.9282 12L11.48 14.0275L8 16L4.52 14.0275L1.0718 12L1.04 8L1.0718 4L4.52 1.97246L8 0Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1851_51750)"
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.00404 0.972656L1.89062 4.48771V11.5155L8.00404 15.0282L14.1127 11.5155V4.48771L8.00404 0.972656ZM12.3028 10.4741L8.00404 12.9455L3.70288 10.4741V5.52668L8.00404 3.0553L12.3028 5.52668V10.4741Z",
    fill: "#002D74"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    d: "M8.00391 15.0282L14.1126 11.5155V4.48771L8.00391 0.972656V3.05766L12.3027 5.52903V10.4765L8.00391 12.9455V15.0282Z",
    fill: "url(#paint0_linear_1851_51750)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    d: "M8 0.971834L1.89133 4.48454L1.89133 11.5123L8 15.0273V12.9423L3.70122 10.471V5.5235L8 3.05448V0.971834Z",
    fill: "url(#paint1_linear_1851_51750)"
  }), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.8534 9.64265L8.00013 11.2824L5.14453 9.64265V6.36084L8.00013 4.71875L10.8534 6.36084L9.66571 7.04406L8.00013 6.08519L6.33456 7.04406V8.95708L8.00013 9.91594L9.66571 8.95708L10.8534 9.64265Z",
    fill: "#002D74"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1851_51750",
    x1: 11.0582,
    y1: 15.0282,
    x2: 11.0582,
    y2: 8.00041,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#002D74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#002D74",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1851_51750",
    x1: 4.94567,
    y1: 0.971834,
    x2: 4.94567,
    y2: 7.99959,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#002D74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#002D74",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1851_51750"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14.6667,
    height: 14.6667,
    fill: "white",
    transform: "translate(0.667969 0.667969)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCro);
export default __webpack_public_path__ + "static/media/cro.a4fa86b44a32353d85537718d6b3bc2d.svg";
export { ForwardRef as ReactComponent };